export enum ToolbarButton {
  HOME = 'HOME',
  TENANTS = 'TENANTS',
  INSTANCES = 'ENVIRONMENTS',
  COST_MGMT = 'COST_MGMT',
  MY_ACCOUNT = 'MY_ACCOUNT',
  CATALOGUE = 'CATALOGUE',
  INSPIRATION_LOUNGE = 'INSPIRATION_LOUNGE',
  MY_SANDBOX = 'MY_SANDBOX',
  SERVICES = 'SERVICES',
  COMING_SOON = 'comingsoon'
}
